import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { lazy, Suspense } from 'react';
import { useAuth } from '../lib/auth';

// React.lazy + Suspense, not lazyRouteComponent: these are rendered
// conditionally inside the root, which lazyRouteComponent does not support
// (React 19 reports a conditional use() when it suspends outside a boundary).
const DashboardLayout = lazy(() =>
  import('../components/layout/dashboard-layout').then((m) => ({ default: m.DashboardLayout })),
);
const LoginPage = lazy(() => import('../pages/login').then((m) => ({ default: m.LoginPage })));

function FullPageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas">
      <Loader2 className="h-8 w-8 animate-spin text-fg-muted" aria-label="Loading" />
    </div>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const { user, isLoading } = useAuth();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  // The admin console has its own layout and auth guard.
  if (pathname === '/admin' || pathname.startsWith('/admin/')) {
    return <Outlet />;
  }

  if (isLoading) return <FullPageLoader />;

  return (
    <Suspense fallback={<FullPageLoader />}>
      {user ? (
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      ) : (
        <LoginPage />
      )}
    </Suspense>
  );
}
